import * as React from 'react';

const ListViewFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="list-view-fill_svg__eds-icon--list-view-fill_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g
            id="list-view-fill_svg__eds-icon--list-view-fill_base"
            fillRule="evenodd"
            clipRule="evenodd"
        >
            <path d="M4 4h16v4H4zM4 10h16v4H4zM4 16h16v4H4z" />
        </g>
    </svg>
);

ListViewFillSvg.displayName = 'ListViewFillSvg';
export default ListViewFillSvg;
